import zhCN from 'element-plus/lib/locale/lang/zh-cn';
import jaJP from "element-plus/lib/locale/lang/ja";
import enUS from "element-plus/lib/locale/lang/en";

const eleLocale = {
  'zh-CN': zhCN,
  'ja-JP': jaJP,
  'en-US': enUS,
}

export default eleLocale
